import { render, staticRenderFns } from "./UpgradeOne.vue?vue&type=template&id=87b0748c&scoped=true&"
import script from "./UpgradeOne.vue?vue&type=script&lang=js&"
export * from "./UpgradeOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b0748c",
  null
  
)

export default component.exports